import { TDeviceType } from '@cian/ui-kit';

import { DefaultAnalyticsPayload, SiteType } from '../analytics.types';

interface IGetPageParams {
  deviceType: TDeviceType;
  pageType: 'subsidizedCalculator' | 'offerCalculator';
  extra?: DefaultAnalyticsPayload['page']['extra'];
}

export function getPage({ deviceType, extra, pageType }: IGetPageParams): DefaultAnalyticsPayload['page'] {
  const siteType =
    deviceType === 'phone' ? SiteType.Mobile : deviceType === 'tablet' ? SiteType.Table : SiteType.Desktop;

  return {
    pageType,
    siteType,
    extra,
  };
}
